import axios from 'axios';

export function getFunctionsUrl(): string {
  if (process.env.NODE_ENV === 'development') {
    // Local emulator URL format - use 127.0.0.1 instead of localhost
    return `http://127.0.0.1:5001/${process.env.REACT_APP_FIREBASE_PROJECT_ID}/us-central1`;
  }
  // Production URL format
  return `https://us-central1-${process.env.REACT_APP_FIREBASE_PROJECT_ID}.cloudfunctions.net`;
}

export async function callFunction(path: string, params: Record<string, string>, token: string) {
  const url = new URL(`${getFunctionsUrl()}/${path}`);
  Object.entries(params).forEach(([key, value]) => {
    url.searchParams.append(key, value);
  });

  // console.log('Calling function:', url.toString()); // Debug log

  try {
    const response = await axios.get(url.toString(), {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.error('Axios error:', error.response?.data || error.message);
      throw new Error(error.response?.data?.error || error.message);
    }
    throw error;
  }
} 